import React, { useEffect, useState, useRef, useCallback } from 'react';
import ReactApexChart from 'react-apexcharts';

const HumChart = ({ humidite, annotation, isDoorsChecked  }) => {
    const [isChecked, setIsChecked] = useState(false);
    const [strokeWidth, setStrokeWidth] = useState(3);
    const currentWidth = window.innerWidth;

    useEffect(() => {
        if (currentWidth <= 500) {
            setStrokeWidth(1);
        }
    }, [currentWidth]);

    const chunkSize = 1000 // Number of data points to load per chunk
    const [currentChunk, setCurrentChunk] = useState(1);
    const [displayedData, setDisplayedData] = useState([]);
    const observer = useRef();

    useEffect(() => {
        const newChunk = humidite.slice(0, currentChunk * chunkSize).map(point => ({ x: point[0], y: point[1] }));
        setDisplayedData(newChunk);
    }, [currentChunk, humidite, isDoorsChecked ]);

    const loadMoreRef = useCallback(node => {
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && displayedData.length < humidite.length) {
                setCurrentChunk(prevChunk => prevChunk + 1);
            }
        });
        if (node) observer.current.observe(node);
    }, [displayedData.length, humidite.length]);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const filteredHumidite = displayedData.filter(point => point.y !== undefined && point.y !== null);

    const options = {
        series: [
            {
                name: 'Humidité (%)',
                data: filteredHumidite,
                curve: 'smooth',
            },
        ],
        chart: {
            type: 'line',
            stacked: false,
            height: 400,
            zoom: {
                type: 'x',
                enabled: true,
                autoScaleYaxis: true,
                allowMouseWheelZoom: false

            },
            toolbar: {
                export: {
                    csv: {
                        filename: 'Humidité (%)',
                        columnDelimiter: ',',
                        headerCategory: 'date',
                        headerValue: 'temp',
                        dateFormatter(timestamp) {
                            return new Date(timestamp).toLocaleString().replace(',', '')
                        }
                    },
                    svg: {
                        filename: undefined,
                    },
                    png: {
                        filename: undefined,
                    }
                },
                autoSelected: 'zoom'
            }
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            colors: ["#458EEF"],
            width: strokeWidth,
        },
        markers: {
            size: 0,
        },
        xaxis: {
            type: 'datetime',
        },
        tooltip: {
            shared: true,
            y: {
                formatter: function (val) {
                    return (val)
                }
            },
            x: {
                formatter: function (val) {
                    var date = new Date(val);
                    return date.toString();
                }
            }
        },
        annotations: {
            xaxis: isDoorsChecked ? annotation : [],
        },
    };

    return (
        <div className='bg-white rounded-lg p-2 border border-gray '>
            <div className='flex justify-between items-center'>
                <p className='text-xl font-bold'>Humidité</p>
                {/* <label className="relative inline-flex items-center cursor-pointer">
                    <input
                        type="checkbox"
                        value=""
                        className="sr-only peer"
                        onChange={handleCheckboxChange}
                        checked={isChecked}
                    />
                    <div className="w-9 lg:w-11 h-5 lg:h-6 bg-lightgray peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-lightgray after:border after:rounded-full after:h-4 lg:after:h-5 after:w-4 lg:after:w-5 after:transition-all peer-checked:bg-primary"></div>
                    <span className="ms-3 text-sm font-medium">Portes</span>
                </label> */}
            </div>
            <ReactApexChart options={options} series={options.series} type="line" height={312} />
            <div ref={loadMoreRef}></div>
        </div>
    );
}

export default HumChart;
